import { createBrowserRouter } from 'react-router';

import routes from './routes.tsx';

const index = createBrowserRouter(routes);

export default index;
